/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type LocalizationEntityType = typeof LocalizationEntityType[keyof typeof LocalizationEntityType];


export const LocalizationEntityType = {
  ActionModule: 'ActionModule',
  ServiceModule: 'ServiceModule',
  Company: 'Company',
  CalendarEvent: 'CalendarEvent',
  GenericInAppNotification: 'GenericInAppNotification',
} as const;
